import script from "./HelmOpValuesTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelmOpValuesTab.vue?vue&type=script&setup=true&lang=ts"

import "./HelmOpValuesTab.vue?vue&type=style&index=0&id=9cc1ba42&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cc1ba42"]])

export default __exports__